<template>
  <div>
    <el-dialog title="消费明细" center :visible="true" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="true" :before-close="onClose" width="781px">
      <el-table :data="histories" border size="small" max-height="400px" style="width: 731px"
        v-el-table-infinite-scroll="loadMore" :infinite-scroll-disabled="histories.length == 0">
        <el-table-column label="时间" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ $util.ms2datetime(scope.row.when) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="productName" label="消费项名称" align="center" width="150" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="productQuantity" label="消费项数量" align="center" width="100">
        </el-table-column>

        <el-table-column label="扣除" align="center" width="60">
          <template slot-scope="scope">
            <span>{{ scope.row.costType == 1 ? "法币" : "代币" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="金额(元)" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ (scope.row.amount / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>



        <el-table-column prop="id" label="流水ID" align="center" width="170">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "ConsumeHistoriesDialog";

export default {
  data() {
    return {
      form: {},
      histories: [],
    };
  },
  components: {},

  async created() {
    this.form = dialogutil.getData(DialogName);
    await this.loadHistories(0, 10);
  },

  methods: {
    loadMore() {
      this.loadHistories(this.histories.length, 10);
    },

    async loadHistories(offset, limit) {
      if (offset == 0) {
        this.histories = [];
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/player/getPlayerConsumeHistories`,
          {
            uid: this.form.uid,
            offset: offset,
            limit: limit,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.histories || [];
      this.histories = this.histories.concat(listInResponse);
    },

    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>